/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    Body,
    Body1,
    OenologistDTO,
    PageOenologistDTO
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class OenologistControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        createOenologist(
                    
                    
                    requestBody: Body
    ): Observable<OenologistDTO> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/oenologist`;

            return this._httpClient.post<OenologistDTO>(url, requestBody, requestOptions);
    }


        deleteOenologist(
                    id: number
                    , 
                    
                    requestBody: number
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/oenologist/${id}`;

            return this._httpClient.delete<boolean>(url, requestOptions);
    }


        getOenologist(
                    id: number
    ): Observable<OenologistDTO> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/oenologist/${id}`;

            return this._httpClient.get<OenologistDTO>(url, requestOptions);
    }


        getOenologistPage(
                
                queryParams: {
                    wineryId: number,
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageOenologistDTO> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/oenologist/page`;

            return this._httpClient.get<PageOenologistDTO>(url, requestOptions);
    }


        getOenologists(
    ): Observable<Array<OenologistDTO>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/oenologist`;

            return this._httpClient.get<Array<OenologistDTO>>(url, requestOptions);
    }


        updateOenologist(
                    id: number
                    , 
                    
                    requestBody: Body1
    ): Observable<OenologistDTO> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/oenologist/${id}`;

            return this._httpClient.put<OenologistDTO>(url, requestBody, requestOptions);
    }


}

